
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raise-funds",
      function () {
        return require("private-next-pages/raise-funds.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/raise-funds"])
      });
    }
  